import { render, staticRenderFns } from "./danger.vue?vue&type=template&id=9fedd6a6&scoped=true"
import script from "./danger.vue?vue&type=script&lang=js"
export * from "./danger.vue?vue&type=script&lang=js"
import style0 from "./danger.vue?vue&type=style&index=0&id=9fedd6a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fedd6a6",
  null
  
)

export default component.exports